export default "__VITE_ASSET__BHp1xYNC__"